export const REQUEST_DETAIL_PARTNER_FORM = {
  apollo: {
    noSuitablePartnerMessage: 'onb-partorneditor-apollo-no-suitable-partner-message',
    criticalMatch: 'onb-partner-editor-apollo-critical-match-main-text',
  },
}
